import { useMemo } from "react";

export function useConditionalVisibility(conditionFn: () => boolean): boolean {
  return useMemo(() => conditionFn(), [conditionFn]);
}
